module.exports = __webpack_public_path__ + "8f3c227d1053843fc251c642844768bc.gif";